export type FeatureFlags = Record<string, boolean>;

export const FeatureFlagKeys = {
  ENABLE_ADS: 'ENABLE_ADS',
} as const;
